import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { injectIntl } from "react-intl";
import { NOT_FOUND_ERROR, NOT_FOUND_TITLE, NOT_FOUND_DESCRIPTION, BACK_HOME } from "../../modules/language";
import { PATH_HOME } from "../../path";
import { getMessageString } from "../../utility";

export const PageNotFound = injectIntl(({ intl }) => {
  const navigate = useNavigate();

  return (
    <Box className="pageNotFound">
      <Typography>{getMessageString(intl, NOT_FOUND_ERROR)}</Typography>
      <Typography className="errore404">{getMessageString(intl, NOT_FOUND_TITLE)}</Typography>
      <Typography>{getMessageString(intl, NOT_FOUND_DESCRIPTION)}</Typography>
      <Button onClick={() => navigate(PATH_HOME)}>{getMessageString(intl, BACK_HOME)}</Button>
    </Box>
  );
});
